import React from "react";
var __jsx = React.createElement;
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { DeleteDialog } from 'components/common/DeleteDialog';
import { IconContainer } from 'components/common/SelectSite/SelectSite.style';
import FormBuilder from 'components/content/FormBuilder';
import { AppendIcon, Container, CTAContainer, FieldsContainer, RemoveIcon } from './RepeatedField.style';

var RepeatedField = function RepeatedField(_ref) {
  var field = _ref.field,
      onAppend = _ref.onAppend,
      onRemove = _ref.onRemove;
  var intl = useIntl();

  var _useSnackbar = useSnackbar(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar;

  var _useState = useState(false),
      isRemoveModalOpen = _useState[0],
      setIsRemoveModalOpen = _useState[1];

  return __jsx(Container, null, onRemove && __jsx(DeleteDialog, {
    open: isRemoveModalOpen,
    messageId: "repeatable-fields.disclaimer",
    onClose: function onClose() {
      return setIsRemoveModalOpen(false);
    },
    onConfirm: function onConfirm() {
      setIsRemoveModalOpen(false);
      onRemove();
      enqueueSnackbar(intl.formatMessage({
        id: 'repeatable-fields.removed'
      }), {
        variant: 'success'
      });
    }
  }), __jsx(FieldsContainer, null, __jsx(FormBuilder, {
    formFields: [field]
  })), __jsx(CTAContainer, null, onRemove && __jsx(IconContainer, {
    title: intl.formatMessage({
      id: 'form.remove'
    }),
    onClick: function onClick() {
      return setIsRemoveModalOpen(true);
    }
  }, __jsx(RemoveIcon, null)), onAppend && __jsx(IconContainer, {
    title: intl.formatMessage({
      id: 'form.append'
    }),
    onClick: onAppend
  }, __jsx(AppendIcon, null))));
};

export default RepeatedField;